import * as Sentry from '@sentry/react';
import { environment, sentryDSN } from './constant';

export const initSentry = (currentUser, isProd) => {
    Sentry.init({
        dsn: sentryDSN,
        dataCollection: {
            // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
            // userInfo: false,
            // httpBodies: []
        },
        environment: environment,
        enableLogs: true,
        integrations: [
            Sentry.replayIntegration()
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
        initialScope: {
            user: {
                id: currentUser?.currentUser?.userId,
                email: currentUser?.currentUser?.email,
                userInfo: {
                    username: currentUser?.currentUser?.username,
                    mediaKitUserName: currentUser?.mediaKit?.mediaKit?.fullName,
                }
            }
        }
        // Enable logs to be sent to Sentry
    });
}